import { clsx } from 'clsx'
import { attachDrag } from 'component/Scroll/drag'
import { attachWheel } from 'component/Scroll/wheel'
import { useEffectOnce } from 'hook/useEffectOnce'
import { PartialOptions } from 'overlayscrollbars'
import { OverlayScrollbarsComponent, OverlayScrollbarsComponentRef } from 'overlayscrollbars-react'
import { ReactNode, useEffect, useRef, useState } from 'react'
import css from './Scroll.module.scss'

type Props = {
  children: ReactNode
  className?: string
  fit?: boolean
  drag?: boolean
  wheel?: boolean
  shift?: boolean
  blur?: boolean
}

export type ScrollRef = OverlayScrollbarsComponentRef

export function Scroll(props: Props) {
  const { children, fit, drag, wheel, shift, blur } = props
  const options: PartialOptions = { scrollbars: { autoHide: 'leave', autoHideDelay: 500, clickScroll: true } }
  const ref = useRef<ScrollRef>(null)
  const [left, setLeft] = useState(false)
  const [right, setRight] = useState(false)
  const className = clsx(
    props.className,
    css.scroll,
    fit && css.fit,
    drag && css.drag,
    shift && css.shift,
    blur && css.blur,
    left && css.left,
    right && css.right,
  )

  useEffectOnce(() => {
    const os = ref.current?.osInstance()
    if (!os) return

    const viewport = os.elements().viewport
    if (drag) attachDrag(viewport)
    if (wheel) attachWheel(viewport)
  })

  useEffect(() => {
    if (blur) {
      const os = ref.current?.osInstance()
      if (!os) return

      const listener = () => {
        const left = element.scrollLeft > 0
        const right = element.scrollLeft + element.clientWidth < element.scrollWidth - 1
        setLeft(left)
        setRight(right)
      }

      const element = os.elements().viewport
      element.addEventListener('scroll', listener)
      return () => element.removeEventListener('scroll', listener)
    } else {
      setLeft(false)
      setRight(false)
    }
  }, [blur])

  return <OverlayScrollbarsComponent ref={ref} className={className} options={options}>
    {children}
  </OverlayScrollbarsComponent>
}
